import { DenialResponse } from './../../../../models/manageWarehouse/denial-response.model';
import { DenialRequest } from './../../../../models/manageWarehouse/denial-request.model';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import { DenialService } from './../../../../services/manageWarehouse/denial.service';
import { Component, OnInit, Renderer2 } from '@angular/core';
import { MessageBeep } from 'src/app/wings-mobile/services/messageBeep/messageBeep.service';
import { Globals } from 'src/app/wings-mobile/shared/globals/globals';
import { FormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { NgClass, NgIf } from '@angular/common';
import { ButtonDirective } from 'primeng/button';
import { InputGenericComponent } from '../../../../shared/input-generic/input-generic.component';
import { AlertCustomComponent } from '../../../../shared/alert-custom/alert-custom.component';

@Component({
    selector: 'denial',
    templateUrl: './denial.component.html',
    styleUrls: ['./denial.component.scss'],
    imports: [FormsModule, InputTextModule, NgClass, NgIf, ButtonDirective, InputGenericComponent, AlertCustomComponent, TranslatePipe]
})
export class DenialComponent implements OnInit {

	denials: DenialResponse;

	showDescriptionDenial: boolean;
	saveIsOk: boolean;

	inputFields = [
		{ name: 'denial_label', id: 'denial_label', focus: true, value: null, action: 'this.getDenialParts()', valid: true },
		{ name: 'location', id: 'location', focus: false, value: null, action: '', valid: false },
		{ name: 'quantity', id: 'quantity', focus: false, value: null, action: '', valid: false }
	];

	showAlert: boolean = false;

	errorTitle: string;
	errorMessage: string;
	errorFocus: string;

	constructor(
		private denialService: DenialService,
		private beep: MessageBeep,
		private translate: TranslateService,
		private globals: Globals,
		private renderer: Renderer2
	) {
		this.renderer = renderer;
		this.globals = globals;
		this.denialService = denialService;
		this.beep = beep;
		this.translate = translate;
	}

	ngOnInit(): void {
		this.resetScreen();
		this.showDescriptionDenial = false;
		this.saveIsOk = true;
	}

	getDenialParts() {
		this.inputFields[1].value = null;
		this.inputFields[2].value = null;
		return this.denialService.getDenialLabel(this.inputFields[0].value).
			subscribe({
				next: res => {
					this.denials = res;
					this.inputFields[1].valid = true;
					if (res == null) {
						this.showErrorModal('modal.error', 'label.labelNotFound', 'denial_label')
						this.showDescriptionDenial = false;
						this.resetScreen();
					}
					if (res) {
						if (this.denials.status === "20 - PRINTED") {
							this.showDescriptionDenial = true;
						} else if (this.denials.status === "30 - CLOSED") {
							this.showErrorModal('modal.error', 'label.denialAlreadyDone', 'denial_label')
							this.resetScreen();
						} else if (this.denials.status === "10 - OPEN") {
							this.showErrorModal('modal.error', 'label.labelNotPrinted', 'denial_label')
							this.resetScreen();
						}
					}

				},
				error: error => {
					if (typeof error.error !== 'string') {
						this.resetOnErrorLabelCycleCount(this.translate.instant('modal.connectionFailed'));
					} else {
						this.resetOnErrorLabelCycleCount(this.translate.instant(error.error));
					};
				}
			});
	}

	resetOnErrorLabelCycleCount(errorMsg: string) {
		this.showErrorModal('modal.error', errorMsg, 'denial_label');
		this.inputFields[0].value = null;
		this.showDescriptionDenial = false;
	}

	checkLocation() {
		this.chackNameLocation(1);
		if (this.denials.locationC === this.inputFields[1].value || this.inputFields[1].value === '999999') {
			this.inputFields[2].valid = true;
		} else {
			this.beep.showAlertCustom('modal.error', 'modal.stageNotFound');
			this.inputFields[1].value = null;
		}
	}

	invalidLocation() {
		this.inputFields[2].valid = false;
		this.inputFields[2].value = null;
		this.saveIsOk = true;
	}

	validQuantity() {
		if (this.inputFields[2].value || this.inputFields[2].value === 0) {
			this.saveIsOk = false;
		} else {
			this.saveIsOk = true;
		}
	}

	invalidQuantity() {
		this.saveIsOk = true;
	}

	saveRequestGenerator(): DenialRequest {
		let request: DenialRequest = new DenialRequest();
		request.bkWarehouseUidD = this.globals.user.warehouse.warehouseUidK;
		request.cdsId = this.globals.user.userName;
		request.countedQ = this.inputFields[2].value;
		request.denialUidK = this.denials.denialUidK;
		request.partWhUidK = this.denials.partWhUidK;
		request.subDivisionUidK = this.globals.user.warehouse.bkSubDivisionUidD;
		return request;
	}

	resetScreen() {
		this.showDescriptionDenial = false;
		this.inputFields[0].value = null;
		this.inputFields[1].valid = false;
		this.inputFields[1].value = null;
		this.inputFields[2].valid = false;
		this.inputFields[2].value = null;
		this.inputFields[0].focus = true;
		this.saveIsOk = true;
		this.renderer.selectRootElement('#scanner_id').focus();

	}

	saveDenialLabel() {
		this.denialService.saveDenialLabel(this.saveRequestGenerator()).subscribe({
			next: res => {
				this.resetScreen();
			},
			error: error => {
				if (error) {
					if (error.error.error.messages[0].substring(77, 81) === "nula") {
						this.resetOnErrorLabelCycleCount(this.translate.instant('modal.quantityOtherqNull'))
						this.resetScreen();
					} else if (error.error.error.messages[0].substring(93, 97) === "zero") {
						this.resetOnErrorLabelCycleCount(this.translate.instant('modal.quantityDifferentZero'))
						console.log(error.error.error.messages[0]);
						this.resetScreen();
					}
				} else {
					this.resetOnErrorLabelCycleCount(this.translate.instant(error.error))
					this.resetScreen();
				}
			}
		});
	}

	executeAction(item) {
		eval(item.action);
	}

	focusInputFields(elId: string = 'remove', focusZebra: boolean = false) {
		this.blurInputFields('all');

		if (focusZebra) {
			this.renderer.selectRootElement('#scanner_id').focus();
		} else {
			if (elId !== 'remove') {
				this.renderer.selectRootElement(`#${elId}`).focus();
			}
		}
		if (elId === 'denial_label') {
			this.inputFields[0].focus = true;
		}
	}

	showErrorModal(title: string, msg: string, focus?: string) {
		this.errorTitle = this.translate.instant(title);
		this.errorMessage = this.translate.instant(msg);
		this.errorFocus = focus;
		this.showAlert = true;
		this.beep.errorBeep();
	}

	hideErrorModal(elId: string) {
		if (elId) {
			this.focusInputFields(elId, true);
		}
		this.setInputToInvalid(elId);
		this.inputFields.forEach(item => {
			if (item.id === elId) {
				item.value = null;
			}
		});
		this.showAlert = false;
	}

	setInputToInvalid(elId: string) {
		switch (elId) {
			case 'denial_label':
				this.inputFields[0].valid = true;
				this.inputFields[1].value = null;
				this.inputFields[2].value = null;
				break;
			case 'all':
				this.inputFields.forEach(input => input.valid = true);
			default:
				break;
		}
	}

	blurInputFields(elId: string = 'all') {
		switch (elId) {
			case 'denial_label':
				this.inputFields[0].focus = false;
				break;
			default:
				this.inputFields.forEach(input => input.focus = false);
				break;
		}
	}

	chackNameLocation(position: number) {
		this.inputFields[position].value = this.inputFields[position].value.replaceAll(' ', '');
		this.inputFields[position].value = this.inputFields[position].value.replaceAll('*', '');
	}

}

